module.exports = __webpack_public_path__ + "static/media/heart-svgrepo-com (8).c948c419.svg";